module.exports = __webpack_public_path__ + "img/small-logo.07eb9400.svg";